import { useState, useEffect } from "react";
import DetalleLayout from "../../Layouts/DetalleLayout/DetalleLayout";
import Button from "../../components/common/Button/Button";
import Badge from "../../components/common/Badge/Badge";
import InputSwitch from "../../components/common/Inputs/InputSwitch/InputSwitch";
import InputDropdown from "../../components/common/Inputs/InputDropdown/InputDropdown";
import Input from "../../components/common/Inputs/Input/Input";
import { FiEdit3, FiUser, FiSettings } from "react-icons/fi";
import { getApiInstance } from "../../utils/api";
import "./perfilUsuario.scss";

export default function PerfilUsuario({ user }) {
    const mapearRol = (role) => {
        const roles = {
            1: "Administrador",
            2: "Usuario",
            3: "Supervisor",
            4: "Gestor",
        };
        return roles[role] || "Usuario";
    };

    const [usuario, setUsuario] = useState({
        nombre: user?.name?.split(" ")[0] || "Usuario",
        apellidos: user?.name?.split(" ").slice(1).join(" ") || "Sin apellidos",
        telefono: "91 234 56 78",
        email: user?.email || "usuario@empresa.com",
        perfil: mapearRol(user?.role) || "Usuario",
        acceso: "Gestión",
    });

    const [configuracion, setConfiguracion] = useState({
        notificaciones: true,
        idioma: "es",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [editandoInfo, setEditandoInfo] = useState(false);
    const [infoTemporal, setInfoTemporal] = useState({ ...usuario });

    const idiomasDisponibles = [
        { value: "es", label: "Español" },
        { value: "en", label: "English" },
    ];

    useEffect(() => {
        setInfoTemporal({ ...usuario });
    }, [usuario]);

    const handleGuardarInfo = async () => {
        try {
            setLoading(true);
            const api = getApiInstance();

            setUsuario({ ...infoTemporal });
            setEditandoInfo(false);
            setLoading(false);
        } catch (err) {
            setError("No se pudo actualizar la información");
            setLoading(false);
        }
    };

    const handleCancelarEdicion = () => {
        setInfoTemporal({ ...usuario });
        setEditandoInfo(false);
    };

    const handleNotificacionesChange = async (valor) => {
        try {
            const nuevaConfig = { ...configuracion, notificaciones: valor };
            setConfiguracion(nuevaConfig);

            const api = getApiInstance();
        } catch (err) {
            setError("No se pudo actualizar las notificaciones");
            setConfiguracion({ ...configuracion });
        }
    };

    const renderInformacionUsuario = () => (
        <div className="perfil-usuario__info">
            {!editandoInfo ? (
                <>
                    <div className="perfil-usuario__field">
                        <label>Nombre:</label>
                        <span>{usuario.nombre}</span>
                    </div>
                    <div className="perfil-usuario__field">
                        <label>Apellidos:</label>
                        <span>{usuario.apellidos}</span>
                    </div>
                    <div className="perfil-usuario__field">
                        <label>Teléfono:</label>
                        <span>{usuario.telefono}</span>
                    </div>
                    <div className="perfil-usuario__field">
                        <label>Email:</label>
                        <span>{usuario.email}</span>
                    </div>
                    <div className="perfil-usuario__field">
                        <label>Perfil:</label>
                        <Badge variant="primary">{usuario.perfil}</Badge>
                    </div>
                    <div className="perfil-usuario__field">
                        <label>Acceso:</label>
                        <span>{usuario.acceso}</span>
                    </div>
                </>
            ) : (
                <div className="perfil-usuario__form">
                    <Input
                        type="text"
                        label="Nombre"
                        value={infoTemporal.nombre}
                        onChange={(e) =>
                            setInfoTemporal({
                                ...infoTemporal,
                                nombre: e.target.value,
                            })
                        }
                    />
                    <Input
                        type="text"
                        label="Apellidos"
                        value={infoTemporal.apellidos}
                        onChange={(e) =>
                            setInfoTemporal({
                                ...infoTemporal,
                                apellidos: e.target.value,
                            })
                        }
                    />
                    <Input
                        type="tel"
                        label="Teléfono"
                        value={infoTemporal.telefono}
                        onChange={(e) =>
                            setInfoTemporal({
                                ...infoTemporal,
                                telefono: e.target.value,
                            })
                        }
                    />
                    <Input
                        type="email"
                        label="Email"
                        value={infoTemporal.email}
                        onChange={(e) =>
                            setInfoTemporal({
                                ...infoTemporal,
                                email: e.target.value,
                            })
                        }
                    />
                    <div className="form-field">
                        <label>Perfil:</label>
                        <span className="readonly">{usuario.perfil}</span>
                        <small className="field-note">
                            Este campo no se puede modificar
                        </small>
                    </div>
                    <div className="form-field">
                        <label>Acceso:</label>
                        <span className="readonly">{usuario.acceso}</span>
                        <small className="field-note">
                            Este campo no se puede modificar
                        </small>
                    </div>
                </div>
            )}
        </div>
    );

    const renderConfiguracion = () => (
        <div className="perfil-usuario__config">
            <div className="config-field">
                <div className="config-field-header">
                    <label>Notificaciones</label>
                    <small>Recibir notificaciones de la aplicación</small>
                </div>
                <InputSwitch
                    checked={configuracion.notificaciones}
                    onChange={handleNotificacionesChange}
                />
            </div>

            <div className="config-field">
                <div className="config-field-header">
                    <label>Idioma</label>
                    <small>Selecciona el idioma de la interfaz</small>
                </div>
                <InputDropdown
                    options={idiomasDisponibles}
                    value={
                        idiomasDisponibles.find(
                            (idioma) => idioma.value === configuracion.idioma
                        ) || idiomasDisponibles[0]
                    }
                    onChange={(selectedOption) => {
                        if (selectedOption) {
                            const nuevaConfig = {
                                ...configuracion,
                                idioma: selectedOption.value,
                            };
                            setConfiguracion(nuevaConfig);
                        }
                    }}
                    placeholder="Seleccionar idioma"
                    labelVisible={false}
                    className=""
                />
            </div>
        </div>
    );

    return (
        <DetalleLayout
            title="Perfil de Usuario"
            subtitle="Gestiona tu información personal y configuración de la cuenta"
            backLink="/dashboard"
            loading={loading}
            error={error}
            className="perfil-usuario"
        >
            {error && <div className="error-message">{error}</div>}

            <div className="perfil-usuario__content">
                <div className="perfil-usuario__section">
                    <div className="perfil-usuario__section-header">
                        <div className="section-title">
                            <FiUser className="section-icon" />
                            <h2>Información del Usuario</h2>
                        </div>
                        {!editandoInfo ? (
                            <Button
                                variant="outlined"
                                startIcon={<FiEdit3 />}
                                onClick={() => setEditandoInfo(true)}
                            >
                                Editar
                            </Button>
                        ) : (
                            <div className="edit-actions">
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleCancelarEdicion}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    variant="filled"
                                    size="small"
                                    onClick={handleGuardarInfo}
                                    loading={loading}
                                >
                                    Guardar
                                </Button>
                            </div>
                        )}
                    </div>
                    <div className="perfil-usuario__section-content">
                        {renderInformacionUsuario()}
                    </div>
                </div>

                <div className="perfil-usuario__section">
                    <div className="perfil-usuario__section-header">
                        <div className="section-title">
                            <FiSettings className="section-icon" />
                            <h2>Configuración</h2>
                        </div>
                    </div>
                    <div className="perfil-usuario__section-content">
                        {renderConfiguracion()}
                    </div>
                </div>
            </div>
        </DetalleLayout>
    );
}
